export const navigationBarAvatarMenuOptions = {
    LOGOUT: 'logout',
};
